import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import toastr from "toastr";
import VTooltip from "v-tooltip";
import VBTooltipPlugin from "bootstrap-vue";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "toastr/build/toastr.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "vue-loaders/dist/vue-loaders.css";
import VueLoaders from "vue-loaders";
import vSelect from "vue-select";
import NoOptionResults from "./components/NoOptionResults.vue";
import CardComponent from "./components/Card.vue";
import ManagementCountdownBadge from "./components/ManagementCountdownBadge.vue";
import AlertComponent from "./components/Alert.vue";
import ModalDelete from "./components/DeleteModal.vue";
import MasterOptions from "./components/MasterOptions.vue";
import ChartOptions from "./components/ChartOptions.vue";
import SearchOptions from "./components/SearchOptions.vue";
import UserForm from "./views/users/UserForm.vue";
import SampleTargetForm from "./views/sampleTargets/SampleTargetForm.vue";
import CommercialMixForm from "./views/commercialMix/commercialMixForm.vue";
import BusinessUnitsForm from "./views/businessUnits/businessUnitsForm.vue";
import CostCenterForm from "./views/costCenter/costCenterForm.vue";
import CostCenterUsersForm from "./views/costCenter/costCenterUsersForm.vue";
import MassiveCostCenterUsersForm from "./views/costCenter/massiceCostCenterUsersForm.vue";
import CompositionDetail from "./views/requests/detail/compositions/compositionDetailForm.vue";
import InternalDispatch from "./views/requests/internalDispatch/internalDispatch.vue";
import ExternalDispatch from "./views/requests/externalDispatch/externalDispatch.vue";
import ListDispatch from "./views/requests/confirmDispatch/listDispatch.vue";
import ConfirmDispatch from "./views/requests/confirmDispatch/confirmDispatch.vue";
import ListDetail from "./views/requests/showRequest/listDetail.vue";
import SearchRequests from "./components/searchRequestForm.vue";
import CourierForm from "./views/couriers/CourierForm.vue";
import ArrivalDateForm from "./views/requests/confirmDispatch/ArrivalDateForm.vue";
import DetailsRequestCourier from "./views/requests/confirmDispatch/DetailsRequestCourier.vue";
import ValidWineryDispatch from "./views/requests/validWineryDispatch/validWineryDispatch.vue";
import CloneRequestForm from "./views/requests/cloneRequest/Form.vue";
import SendOnelogyForm from "./views/requests/internalDispatch/sendOenology.vue";
import SendRevisionForm from "./views/requests/internalDispatch/sendRevision.vue";
import SendOneFinisehdProductToRevision from "./views/requests/internalDispatch/sendOneFinisehdProductToRevision.vue"
import SelectNewComponent from "./views/requests/internalDispatch/selectNewComponent.vue"
import OtherSemiElaborateModal from "./views/requests/internalDispatch/otherSemiElaborateModal.vue"
import OtherPtModal from "./views/requests/internalDispatch/otherPtModal.vue";
import DispatchComponentModal from "./views/requests/internalDispatch/internalDispatch.vue";
import CityForm from "./views/city/CityForm.vue"
import MassiveCostCenterUpdate from "./views/businessUnits/massiveCostCenterUpdate.vue"
import StepStatusComponent from "./components/StepStatusComponent.vue";
import MassiveActivatedMasterItems from "./views/masterItems/massiveActivatedMasterItems.vue"
import ShowCostCenterUsers from "./views/costCenter/showCostCenterUsers.vue"
import SampleReasonForm from './views/sampleReason/sampleReasonForm.vue'
import "vue-select/dist/vue-select.css";
import $ from "jquery";
import VueSweetalert2 from "vue-sweetalert2";
import VModal from "vue-js-modal";
import Modal from "./global/Modal.vue";
import Popover from "vue-js-popover";
import VPopover from "vue-js-popover";
import "../public/dimabe-style.css";
import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css'

Vue.component("v-select", vSelect);
Vue.component("no-option-result", NoOptionResults);
Vue.component("modal-delete", ModalDelete);
Vue.component("master-options", MasterOptions);
Vue.component("chart-options", ChartOptions);
Vue.component("search-options", SearchOptions);
Vue.component("user-form", UserForm);
Vue.component("sample-target-form", SampleTargetForm);
Vue.component("commercial-mix-form", CommercialMixForm);
Vue.component("business-units-form", BusinessUnitsForm);
Vue.component("cost-center-form", CostCenterForm);
Vue.component("cost-center-users-form", CostCenterUsersForm);
Vue.component("massive-cost-center-users-form", MassiveCostCenterUsersForm);
Vue.component("composition-detail-form", CompositionDetail);
Vue.component("internal-dispatch", InternalDispatch);
Vue.component("external-dispatch", ExternalDispatch);
Vue.component("list-dispatch", ListDispatch);
Vue.component("confirm-dispatch", ConfirmDispatch);
Vue.component("list-detail", ListDetail);
Vue.component("modal", Modal);
Vue.component("search-request-form", SearchRequests);
Vue.component("courier-form", CourierForm);
Vue.component("details-request-courier", DetailsRequestCourier);
Vue.component("arrival-date", ArrivalDateForm);
Vue.component("valid-winery-dispatch", ValidWineryDispatch);
Vue.component("paginator", require("./global/PaginatorComponent").default);
Vue.component("manage-table", require("./global/manageTable").default);
Vue.component("clone-request-form", CloneRequestForm);
Vue.component("send-oenology-form", SendOnelogyForm);
Vue.component("send-revision-form", SendRevisionForm);
Vue.component("send-one-finished-product-to-revision-form", SendOneFinisehdProductToRevision)
Vue.component("select-new-component-form", SelectNewComponent)
Vue.component("other-semielaborate-modal", OtherSemiElaborateModal)
Vue.component("other-pt-modal", OtherPtModal)
Vue.component("dispatch-component-modal", DispatchComponentModal)
Vue.component("city-form", CityForm);
Vue.component("massive-costenter-update", MassiveCostCenterUpdate)
Vue.component("step-status-component", StepStatusComponent)
Vue.component("massive-activated-masteritems", MassiveActivatedMasterItems)
Vue.component("show-cost-center-users", ShowCostCenterUsers)
Vue.component("management-countdown-badge", ManagementCountdownBadge)
Vue.component("sample-reason-form", SampleReasonForm);
Vue.use(VueSweetalert2);
Vue.use(VModal);
Vue.use(VTooltip);
Vue.use(VBTooltipPlugin);
Vue.use(Popover);
Vue.use(VPopover, { tooltip: true });
Vue.config.productionTip = false;

window.toastr = toastr;

Vue.component("vue-loader", VueLoaders.component);
Vue.component("card", CardComponent);
Vue.component("alert", AlertComponent);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

//PARA TOOLTIP PERO HAY QYE REVISAR YA QUE FUNCIONA SIEMPRE
$(function () {
  $('[data-toggle="tooltip"]').tooltip();
});
